import React from "react";
import Card from "@mui/material/Card";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Typography from "@mui/material/Typography";
import LaunchIcon from "@mui/icons-material/Launch";
import { styled } from "@mui/material/styles";

import CardIcon from "./CardIcon";

// Styled components
const Container = styled("div")({
  flex: "1",
  marginRight: "1em",
  marginTop: 20,
});

const StyledCard = styled(Card)({
  overflow: "inherit",
  textAlign: "right",
  padding: 16,
  minHeight: 52,
});

const Revenue = ({ title, value, text, text2 = "", launchLink = "" }) => {
  return (
    <Container>
      <CardIcon Icon={AttachMoneyIcon} bgColor="#31708f" />
      <StyledCard>
        {launchLink && (
          <a target="_blank" rel="noopener noreferrer" href={launchLink}>
            <LaunchIcon />
          </a>
        )}
        <Typography color="textSecondary">{title}</Typography>
        <Typography variant="h5" component="h2">
          {value}
        </Typography>
        <Typography>{text}</Typography>
        <Typography>{text2}</Typography>
      </StyledCard>
    </Container>
  );
};

export default Revenue;
